/*
 * DUO — omzetten van twee losse kunstwerken naar één duo
 * ======================================================
 * Hoort bij snippets/duo-cart-nudge.liquid (markup en config) en de
 * .duo-nudge-regels in assets/petterns-custom.css.
 *
 * Wat dit bestand doet
 * --------------------
 * 1. luistert gedelegeerd op <document>, want de melding zit in [data-products]
 *    en die knoop wordt door theme.js bij elke hoeveelheidswijziging volledig
 *    vervangen. Een listener op het element zelf zou die vervanging niet
 *    overleven; een listener op document wel, en hij komt er maar één keer.
 * 2. controleert vóór het omzetten of de winkelwagen nog is wat Liquid zag. De
 *    melding is server-side gerenderd, dus tussen renderen en klikken kan er in
 *    een ander tabblad iets veranderd zijn.
 * 3. zet de duo-variant in de winkelwagen mét de vier properties, en haalt
 *    daarna pas de losse regels eruit. In die volgorde, want andersom is de
 *    klant zijn kunstwerken kwijt zodra het toevoegen mislukt. Dat zijn twee
 *    regels van één stuk, of één regel van twee stuks; het snippet geeft ze als
 *    `regels` mee, elk met de hoeveelheid die erop hoort te staan.
 * 4. laat het theme de winkelwagen hertekenen. Zijn er daarna nog twee losse
 *    werken die samen kunnen, dan verschijnt de melding vanzelf opnieuw voor dat
 *    paar.
 *
 * Nooit automatisch: de klant heeft die twee regels bewust in zijn mand gelegd,
 * dus de omzetting gebeurt alleen op zijn klik.
 *
 * Dat is de omzetting. Onderaan staat de meting van de tweede melding
 * (.duo-info): zelfde maat, andere kleur, geen knop. Die melding is niet om te
 * zetten, dus daar valt alleen een impressie te meten.
 *
 * Geladen vanuit snippets/cart-drawer.liquid (staat op elke pagina, via
 * sections/header.liquid) en sections/main-cart.liquid. Beide plekken kunnen dit
 * bestand binnenhalen, dus de vlag hieronder houdt het bij één keer.
 */
(function () {
  'use strict';

  if (window.PetternsDuoCart) return;
  window.PetternsDuoCart = true;

  var FOUT_TOEVOEGEN = 'Omzetten lukte niet. Je winkelwagen is ongewijzigd.';
  var FOUT_OPRUIMEN = 'Het duo staat in je winkelwagen. De losse regels konden we niet weghalen. Laad de pagina opnieuw en haal ze er zelf uit.';
  var FOUT_GEWIJZIGD = 'Je winkelwagen is inmiddels gewijzigd. We hebben hem opnieuw geladen.';

  var bezig = false;

  function jsonPost(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function leesConfig(blok) {
    var el = blok.querySelector('[data-duo-nudge-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function toonFout(blok, tekst) {
    var p = blok.querySelector('[data-duo-nudge-fout]');
    if (!p) return;
    p.textContent = tekst;
    p.hidden = false;
  }

  function zetKnop(blok, uit, tekst) {
    var b = blok.querySelector('[data-duo-nudge-btn]');
    if (!b) return;
    b.disabled = uit;
    if (tekst) b.textContent = tekst;
  }

  /* Het theme hertekent beide oppervlakken op dit event: zowel het formulier van
     de winkelwagenpagina als dat van de drawer heeft er een CartForm op zitten
     (assets/theme.js). Bewust niet 'ajaxProduct:added', want dat opent de drawer
     ook op de winkelwagenpagina zelf. */
  function hertekenCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  /* De melding is server-side gerenderd. Klikt de klant nadat hij in een ander
     tabblad iets aan zijn winkelwagen veranderde, dan kloppen de keys of de
     prijzen niet meer en zou de omzetting het verkeerde weghalen. */
  function controleer(cfg) {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var som = 0;
        for (var i = 0; i < cfg.regels.length; i++) {
          var wens = cfg.regels[i];
          var regel = null;
          for (var j = 0; j < items.length; j++) {
            if (items[j].key === wens.key) { regel = items[j]; break; }
          }
          if (!regel || regel.quantity !== wens.aantal) return false;
          /* final_line_price is het regeltotaal, dus bij twee stuks op één regel
             telt hij vanzelf voor twee. */
          som += regel.final_line_price;
        }
        return som === cfg.losPrijs;
      })
      .catch(function () { return false; });
  }

  /* Eén voor één: /cart/change.js verwerkt geen batch, en op key wijzigen betekent
     dat de regelnummers niet onder ons vandaan schuiven. Een mislukte regel stopt
     de rij niet, want de tweede regel moet er hoe dan ook uit. Geeft terug hoeveel
     er zijn blijven staan. */
  function verwijderRegels(regels) {
    var mislukt = 0;
    return regels.reduce(function (p, wens) {
      return p.then(function () {
        return jsonPost('/cart/change.js', { id: wens.key, quantity: 0 })
          .catch(function () { mislukt += 1; });
      });
    }, Promise.resolve()).then(function () { return mislukt; });
  }

  function zetOm(blok) {
    if (bezig) return;
    var cfg = leesConfig(blok);
    if (!cfg || !cfg.variantId || !cfg.regels || !cfg.regels.length) return;
    /* Er moeten precies twee kunstwerken weggaan: twee regels van één, of één
       regel van twee. Klopt dat niet, dan is de config niet die van dit snippet. */
    var stuks = 0;
    for (var i = 0; i < cfg.regels.length; i++) stuks += cfg.regels[i].aantal || 0;
    if (stuks !== 2) return;

    bezig = true;
    zetKnop(blok, true, 'Bezig…');
    var fout = blok.querySelector('[data-duo-nudge-fout]');
    if (fout) fout.hidden = true;

    controleer(cfg)
      .then(function (klopt) {
        if (!klopt) {
          toonFout(blok, FOUT_GEWIJZIGD);
          zetKnop(blok, true, 'Maak er een duo van');
          bezig = false;
          hertekenCart();
          return null;
        }
        return jsonPost('/cart/add.js', {
          items: [{ id: cfg.variantId, quantity: 1, properties: cfg.properties }]
        }).then(function () {
          /* Pas opruimen als het duo er echt in staat. */
          return verwijderRegels(cfg.regels);
        }).then(function (mislukt) {
          bezig = false;
          if (mislukt) {
            /* Bewust géén hertekening: die vervangt dit blok en daarmee de
               melding, terwijl de klant juist moet weten dat er iets is blijven
               staan. De knop blijft uit, anders komt er een tweede duo bij. */
            toonFout(blok, FOUT_OPRUIMEN);
            zetKnop(blok, true, 'Maak er een duo van');
            return;
          }
          hertekenCart();
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'duo_cart_omzetten', {
              duo_vorm: cfg.vorm || '',
              duo_kleur: cfg.kleur || '',
              duo_maat: cfg.maat || '',
              duo_design_1: (cfg.properties || {})['Design 1'] || '',
              duo_design_2: (cfg.properties || {})['Design 2'] || ''
            });
          }
        });
      })
      .catch(function () {
        bezig = false;
        zetKnop(blok, false, 'Maak er een duo van');
        toonFout(blok, FOUT_TOEVOEGEN);
      });
  }

  document.addEventListener('click', function (e) {
    var knop = e.target && e.target.closest ? e.target.closest('[data-duo-nudge-btn]') : null;
    if (!knop) return;
    var blok = knop.closest('[data-duo-nudge]');
    if (!blok) return;
    e.preventDefault();
    zetOm(blok);
  });

  /* ==================================================================
     Meting van de mededeling bij zelfde maat en andere kleur
     ==================================================================
     Er is niets te klikken, dus zonder impressie weten we niet of dit geval
     voorkomt. Juist dat cijfer bepaalt of hier later een kleurkeuze bij moet.

     Waarom zichtbaarheid en niet het bestaan van het element: de drawer staat
     via sections/header.liquid op élke pagina in de DOM. Dicht is hij
     display:none, dus wie zijn winkelwagen nooit opent zou anders wel een
     impressie opleveren. Een IntersectionObserver ziet een display:none-element
     nooit, en zodra de drawer opengaat wel.

     Ontdubbeld op vorm, maat en beide kleurcodes, één keer per paginabezoek. Het
     theme vervangt [data-products] bij elke hoeveelheidswijziging en op de
     winkelwagenpagina staan de sectie en de drawer bovendien naast elkaar; beide
     zouden hetzelfde paar melden. */
  var gemeten = {};

  function meetKleurverschil(blok) {
    var el = blok.querySelector('[data-duo-info-config]');
    if (!el) return;
    var cfg;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
    var sleutel = [cfg.vorm, cfg.maat, cfg.code1, cfg.code2].join('|');
    if (gemeten[sleutel]) return;
    /* Pas afvinken als het event echt weg is. Staat gtag er nog niet, dan blijft
       de sleutel vrij en meet een volgende hertekening hem alsnog. */
    if (typeof window.gtag !== 'function') return;
    gemeten[sleutel] = true;
    window.gtag('event', 'duo_cart_kleurverschil', {
      duo_vorm: cfg.vorm || '',
      duo_maat: cfg.maat || '',
      duo_kleur_1: cfg.kleur1 || '',
      duo_kleur_2: cfg.kleur2 || '',
      duo_bespaar: (cfg.bespaar || 0) / 100
    });
  }

  var kijker = null;
  if (typeof window.IntersectionObserver === 'function') {
    kijker = new IntersectionObserver(function (regels) {
      for (var i = 0; i < regels.length; i++) {
        if (!regels[i].isIntersecting) continue;
        kijker.unobserve(regels[i].target);
        meetKleurverschil(regels[i].target);
      }
    }, { threshold: 0.5 });
  }

  /* data-duo-gemeten houdt bij welke blokken al onder de observer hangen. Een
     hertekening levert een nieuwe knoop zonder dat kenmerk, dus die wordt wel
     opnieuw opgepakt. */
  function zoekMeldingen() {
    var lijst = document.querySelectorAll('[data-duo-info]');
    for (var i = 0; i < lijst.length; i++) {
      if (lijst[i].getAttribute('data-duo-gemeten')) continue;
      lijst[i].setAttribute('data-duo-gemeten', '1');
      if (kijker) {
        kijker.observe(lijst[i]);
      } else if (lijst[i].offsetParent !== null) {
        /* Zonder IntersectionObserver is offsetParent de enige goedkope toets op
           een dichte drawer: display:none geeft null. */
        meetKleurverschil(lijst[i]);
      }
    }
  }

  /* Het script staat op defer, dus de DOM is compleet. */
  zoekMeldingen();

  if (typeof window.MutationObserver === 'function') {
    var gepland = false;
    new MutationObserver(function (muts) {
      if (gepland) return;
      for (var i = 0; i < muts.length; i++) {
        if (!muts[i].addedNodes || !muts[i].addedNodes.length) continue;
        /* Deze observer luistert op de hele body, want [data-products] wordt zelf
           vervangen. Daarom niet bij elke mutatie zoeken maar één keer per frame:
           apps en sliders muteren de pagina voortdurend. */
        gepland = true;
        window.setTimeout(function () {
          gepland = false;
          zoekMeldingen();
        }, 0);
        return;
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
}());
